import React, { Suspense, useMemo, useEffect, useState } from "react";
import { Loading } from "../components/shared";
import useAuth from "../utils/hooks/useAuth";
import { io } from "socket.io-client";
import { useSelector } from "react-redux";

const Layout = () => {
  //   const [socket, setSocket] = useState(() => io("http://localhost:5002"));

  //   useEffect(() => {
  //     // setSocket(io("http://localhost:5002"));
  //     const socket = io("http://localhost:5002");
  //   }, []);
  //   console.log(socket);

  // useEffect(() => {
  //   if (socket) {
  //     socket.on("newRequest", (data) => {
  //       console.log(data);
  //     });
  //   }
  // }, [socket]);

  const { authenticated } = useAuth();
  // const authenticated=true
  const AppLayout = useMemo(() => {
    if (authenticated) {
      return React.lazy(() => import("./main"));
    }

    return React.lazy(() => import("./authLayout"));
  }, [authenticated]);

  return (
    <Suspense
      fallback={
        <div className="flex flex-auto flex-col h-[100vh]">
          <Loading loading={true} />
        </div>
      }
    >
      <AppLayout />
    </Suspense>
  );
};

export default Layout;
